import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');

const KEYBOARD_CLASS = 'vjs-probably-keyboard-focus';

class DetectKeyboardFocus extends Plugin {
    constructor(player, options) {
        super(player, options);

        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleMousedown = this.handleMousedown.bind(this);

        window.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('mousedown', this.handleMousedown);

        this.on('statechanged', this.handleStateChange);

        this.toggleClassName();
    }

    dispose() {
        super.dispose();
        window.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('mousedown', this.handleMousedown);
    }

    toggleClassName() {
        this.player.toggleClass(KEYBOARD_CLASS, this.state.probablyKeyboard);
    }

    handleStateChange(event, data) {
        if (event.changes.probablyKeyboard) {
            this.toggleClassName();
        }
    }

    handleKeydown(event) {
        if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') {
            this.setState({ probablyKeyboard: true });
        }
    }

    handleMousedown(event) {
        this.setState({ probablyKeyboard: false });
    }
}

DetectKeyboardFocus.defaultState = {
    probablyKeyboard: false
};

videojs.registerPlugin('detectKeyboardFocus', DetectKeyboardFocus);

export default DetectKeyboardFocus;



// WEBPACK FOOTER //
// ./src/player/plugins/DetectKeyboardFocus.js